
$(function () {

    /* toggle order */
    $('[data-toggle="payment-toggle"]').on('click', function() {
        $(this).toggleClass('_opened');

        if ($(this).hasClass('_opened')) {
            $('[data-toggle-content="payment-toggle"]').slideDown(300);
        } else {
            $('[data-toggle-content="payment-toggle"]').slideUp(300);
        }
    });

    //init header icons count: favorite & cart
    showFavoritesCount();

    /* phone mask */
    $('input[type="tel"]').mask('+7(000)000-00-00');
    document.addEventListener('DOMContentMutated', (e) => {
        $('input[type="tel"]').mask('+7(000)000-00-00');
    });

    //О Компании меню
    $('.have_drop img, .have_drop .header_top-content-about').on('mouseenter', function () {
        $('.have_drop img').addClass('active');
        $('.have_drop .drop').removeClass('active');
    });

    $('.have_drop').on('mouseleave', function () {
        $('.have_drop img').removeClass('active');
        $('.have_drop .drop').addClass('active');
    });

    //Связаться с нами
    $('.contact_us-title').on('click', function () {
        $('.contact_us-content').toggleClass('active');
        $('.contact_us-title .arrow_down').toggleClass('active');
    });

    // Каталог меню
    $('.have_menu-name').on('click', function () {
        let orderContent = $(this).closest('.have_menu').find('.menu_drop');
        orderContent.slideToggle();
    });

    // меню при ресайзе
    let mobile = false;
    let auth = $('.auth');
    let allProduct = $('.all_product');
    let popularAllProduct = $('.popular_all-product');
    let meatAllProduct = $('.meat_all-product');
    let drinkAllProduct = $('.drink_all-product');
    let productName = $('.zakaz_body-name');
    let productName1 = $('.zakaz_body-name1');
    let productHead = $('.zakaz_head');
    let formHeart = $('.tovar_price-content .card_heart, [data-fav-add]');

    if ($(window).width() < 1020) {
        mobile = true;
        // $(".zakaz_body-content").prepend(productName);
        // $(".zakaz_body-content1").prepend(productName1);
        $('.zakaz_body-wrap').prepend(productHead);
    }

    if ($(window).width() < 992) {
        mobile = true;
        $('.tovar_price-wrapper .number').append(formHeart);
    }

    if ($(window).width() < 768) {
        mobile = true;
        $('header .menu').append(auth);
        $('.section_title').append(allProduct);
        $('.popular_section-title').append(popularAllProduct);
        $('.meat_section-title').append(meatAllProduct);
        $('.drink_section-title').append(drinkAllProduct);
    }

    if ($(window).width() < 600) {
        mobile = true;
    }

    $(window).on('resize', function () {
        if ($(window).width() < 1020) {
            // mobile = true;
            // $(".zakaz_body-wrap").prepend(productHead);
            // $(".zakaz_body-content").prepend(productName);
            // $(".zakaz_body-content1").prepend(productName1);
        }

        if ($(window).width() >= 1020) {
            // mobile = false;
            // $(".zakaz_left").prepend(productHead);
            // $(".zakaz_item-wrap").append(productName);
            // $(".zakaz_item-wrap1").append(productName1);
        }

        if ($(window).width() < 992) {
            // mobile = true;
            $('.tovar_price-wrapper .number').append(formHeart);
        }

        if ($(window).width() >= 992) {
            // mobile = false;
            $('.tovar_price-content').append(formHeart);
        }

        if ($(window).width() < 768 && !mobile) {
            mobile = true;
            $('header .menu').append(auth);
            $('.section_title').append(allProduct);
            $('.popular_section-title').append(popularAllProduct);
            $('.meat_section-title').append(meatAllProduct);
            $('.drink_section-title').append(drinkAllProduct);
        }

        if ($(window).width() >= 768 && mobile) {
            mobile = false;
            $('header .container').append(auth);
            $(this, 'header .menu').removeClass('active');
            $('.discount_section .container').append(allProduct);
            $('.popular .container').append(popularAllProduct);
            $('.catalog_meat .container').append(meatAllProduct);
            $('.catalog_drink .container').append(drinkAllProduct);
        }
    });

    // Banner слайдер
    $('.banner_slider').slick({
        dots: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 4000
    });
    $('.banner_slider .banner_item').css('display', 'block');

    $('[data-product-slider]').slick({
        infinite: false,
        autoplay: false,
        slidesToShow: 5,
        slidesToScroll: 5,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                }
            },
        ]
    });

    $('[data-regular-product-slider]').slick({
        infinite: false,
        autoplay: false,
        slidesToShow: 3,
        slidesToScroll: 3,
        prevArrow: '[data-regular-product-slider-block] [data-arrow-left]',
        nextArrow: '[data-regular-product-slider-block] [data-arrow-right]',
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    variableWidth: true
                }
            },
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }
            },
        ]
    });



    // Нам доверяют слайдер
    $('.we_trust-slider').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        responsive: [
            {
                breakpoint: 880,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true
                }
            },
            {
                breakpoint: 525,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true
                }
            }
        ]
    });
    // Нам доверяют слайдер
    $('[data-vacancy-slider]').slick({
        variableWidth: true,
        infinite: true,
        // slidesToShow: 3,
        // slidesToScroll: 1,
        // autoplay: true,
        // autoplaySpeed: 2000,
        // responsive: [
        //     {
        //         breakpoint: 880,
        //         settings: {
        //             slidesToShow: 2,
        //             slidesToScroll: 1,
        //             infinite: true
        //         }
        //     },
        //     {
        //         breakpoint: 525,
        //         settings: {
        //             slidesToShow: 1,
        //             slidesToScroll: 1,
        //             infinite: true
        //         }
        //     }
        // ]
    });

    // Отзывы Слайдер
    const reviewsSlider = $('.reviews_slider-container').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1
    });
    $('[ data-slider-modal-slide]').on('click', function () {
        if (reviewsSlider) {
            reviewsSlider.slick('slickGoTo', $(this).index());
        }
    });

    //Товар Слайдер
    $('.tovar_slider-top').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        asNavFor: '.tovar_slider-bottom'
    });
    $('.tovar_slider-bottom').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        asNavFor: '.tovar_slider-top'
    });

    //news page slider
    $('.js-news-image-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        infinite: false
    });

    function updateBasketTotal(response) {
        let totalPrice = response['basket_total'];
        const hasWeight = response['has_weight'];
        $('[data-new-price]').html(totalPrice + ' ₽');
        let totalOldPrice = response['basket_nodiscount_total'];
        $('[data-old-price]').html(totalOldPrice > totalPrice ? totalOldPrice + ' ₽' : '');
        let benefitString = '';
        if (totalOldPrice > totalPrice) {
            let benefit = totalOldPrice - totalPrice;
            benefit = Math.round(benefit);
            benefitString = "Выгода: " + Math.round(benefit) + ' ₽';
        }
        $('[data-benefit]').html(benefitString);
        $('[data-cart-total]').html(totalPrice);

        let totalCount = response['basket_total_count'];
        showBasketCount(totalCount);

        let total = $('[data-total-error-message]');
        let sendBtn = $('[data-create-order-button]');
        // let hasDebt = !!sendBtn[0].dataset.hasDebt;
        let totalValid = totalPrice > total.data('basket-min-total');

        totalValid ? total.hide() : total.show();

        // if (totalValid && !hasDebt) {
        if (totalValid) {
            sendBtn[0].classList.remove('_disabled');
            sendBtn[0].dataset.goalYandexClick = 'click_oformit_zakaz'
            sendBtn[0].dataset.goalGoogleClick = 'oformit_zakaz#click'
        } else {
            sendBtn[0].classList.add('_disabled');
            sendBtn[0].removeAttribute('data-goal-yandex-click');
            sendBtn[0].removeAttribute('data-goal-google-click');
        }

        const weightElement = document.querySelector('[data-weight-message]');
        if (weightElement) {
            if (hasWeight) {
                weightElement.classList.remove('_hide');
            } else {
                weightElement.classList.add('_hide');
            }
        }
        document.dispatchEvent(new Event('update-product-counts'));
    }
    document.addEventListener('product-returned', (e) => {
        updateBasketTotal(e.detail);
    });
    document.addEventListener('basket-clear', (e) => {
        updateBasketTotal(e.detail);
    });
    function showBasketCount(responseCount) {
        let $favoriteCount = $('[data-cart-count]');

        $favoriteCount.html(responseCount).removeClass('--hide');

        if (responseCount > 0) {
            $favoriteCount.removeClass('_empty');
        } else {
            $favoriteCount.addClass('_empty');
        }
    }

    // Product счетчик
    $('.js-input-count[data-increment]').change(function () {
        const $input = $(this);
        const value = parseFloat($input.val());
        const increment = parseFloat($input.data('increment'));
        const avails = parseFloat($input.data('avail'));

        // Текущий множитель
        const multiplier = Math.floor(value / increment).toFixed(0);

        // Множитель для максимального количества
        const availsMultiplier = Math.floor(avails / increment).toFixed(0);

        // Максимальное количество по множителям
        const computedAvails = Math.round(availsMultiplier * increment * 100) / 100;


        let newValue = increment * multiplier;
        newValue = Math.round(newValue * 100) / 100;


        if (computedAvails && newValue > computedAvails) {   // Если набрано больше возможного
            newValue = computedAvails;
        } else if (newValue < increment) { // Если набрано меньше минимального
            newValue = increment;
        } else if (newValue !== value && newValue + increment <= computedAvails) { // Если отличается от набранного и можно подсунуть еще
            newValue += increment;
        }

        $input.val(newValue);
        return false;
    });
    $('.minus1').click(function () {
        var $input = $(this).parent().find('input');
        const value = parseFloat($input.val());
        const increment = parseFloat($input.data('increment'));
        let newValue = value - increment;
        newValue = Number.isInteger(newValue) ? newValue.toFixed(0) : parseFloat(newValue.toFixed(2));
        if (newValue < increment) {
            newValue = increment;
        }
        $input.val(newValue);
        $input.change();
        return false;
    });
    $('.plus1').click(function () {
        var $input = $(this).parent().find('input');
        const value = parseFloat($input.val());
        const increment = parseFloat($input.data('increment'));
        const avails = parseFloat($input.data('avail'));

        let newValue = value + increment;
        newValue = Number.isInteger(newValue) ? newValue.toFixed(0) : parseFloat(newValue.toFixed(2));
        if (avails && newValue > avails) {
            newValue = avails;
        }
        $input.val(newValue);
        $input.change();
        return false;
    });

    $(document).on('click', '.basket_minus', function () {
        var $input = $(this).parent().find('input');
        $input.attr('disabled', 'disabled');
        let product = $(this).data('product');
        let csrfParam = $('meta[name="csrf-param"]').attr('content');
        let csrfToken = $('meta[name="csrf-token"]').attr('content');
        $.ajax({
            type: 'POST',
            contentType: 'application/x-www-form-urlencoded',
            url: `${window.location.origin}/basket/minus/` + product,
            data: {[csrfParam]: csrfToken},
            success: function (response) {
                let amount = parseFloat(response['item_amount']);
                amount = Math.round(amount * 100) / 100;
                $input.val(amount);
                $input.removeAttr('disabled');
                $input
                  .parent()
                  .parent()
                  .parent()
                  .next('.total_value')
                  .html(response['item_total'] + '₽');
                $input
                  .parent()
                  .parent()
                  .next('.price_container')
                  .children('div')
                  .html(response['item_total'] + '₽');
                updateBasketTotal(response);
                document.dispatchEvent(new Event('changeProductQuantity'));
            },
            error: function (response) {
                $input.removeAttr('disabled');
            }
        });
        return false;
    });

    $(document).on('change', '.product_input_count', function () {
        var $input = $(this);
        var $count = $(this).val();
        if ($count > 0) {
            $input.attr('disabled', 'disabled');
            let product = $(this).data('product');
            let csrfParam = $('meta[name="csrf-param"]').attr('content');
            let csrfToken = $('meta[name="csrf-token"]').attr('content');

            $.ajax({
                type: 'POST',
                contentType: 'application/x-www-form-urlencoded',
                url: `${window.location.origin}/basket/count/` + product,
                data: {[csrfParam]: csrfToken, count: $count},
                success: function (response) {
                    let amount = parseFloat(response['item_amount']);
                    amount = Math.round(amount * 100) / 100;
                    $input.val(amount);
                    $input.removeAttr('disabled');
                    $input
                      .parent()
                      .parent()
                      .parent()
                      .next('.total_value')
                      .html(response['item_total'] + '₽');
                    $input
                      .parent()
                      .parent()
                      .next('.price_container')
                      .children('div')
                      .html(response['item_total'] + '₽');
                    updateBasketTotal(response);
                },
                error: function (response) {
                    $input.removeAttr('disabled');
                }
            });
            return false;
        }
    });

    $(document).on('click', '.basket_plus', function () {
        var $input = $(this).parent().find('input');
        $input.attr('disabled', 'disabled');
        let product = $(this).data('product');
        let csrfParam = $('meta[name="csrf-param"]').attr('content');
        let csrfToken = $('meta[name="csrf-token"]').attr('content');

        $.ajax({
            type: 'POST',
            contentType: 'application/x-www-form-urlencoded',
            url: `${window.location.origin}/basket/plus/` + product,
            data: {[csrfParam]: csrfToken},
            success: function (response) {
                let amount = parseFloat(response['item_amount']);
                amount = Math.round(amount * 100) / 100;
                // console.log(amount, response['item_amount'])
                $input.val(amount);
                $input.removeAttr('disabled');
                $input
                    .parent()
                    .parent()
                    .parent()
                    .next('.total_value')
                    .html(response['item_total'] + '₽');
                $input
                    .parent()
                    .parent()
                    .next('.price_container')
                    .children('div')
                    .html(response['item_total'] + '₽');
                updateBasketTotal(response);
                document.dispatchEvent(new Event('changeProductQuantity'));
            },
            error: function (response) {
                $input.removeAttr('disabled');
            }
        });
        return false;
    });

    // Свич Блок Контакты
    $('[data-switch]').on('click', function (e) {
        $('[data-switch], [data-switched]').removeClass('active');
        let s = $(this).attr('data-switch');
        $(this).addClass('active');
        $('[data-switched=' + s + ']').addClass('active');
    });

    document.querySelectorAll('.modal').forEach(function (item) {
        item.addEventListener('click', function (e) {
            if (e.target === this || e.target.classList.contains('close')) {
                document.body.style.overflow = 'visible';
                this.style.display = 'none';
            }
        });
    });

    //Аккардион
    $('.table_body img').on('click', function () {
        this.classList.toggle('active');
        let orderContent = $(this).closest('.table_body-content').find('.table_body-accordion');
        orderContent.slideToggle();
    });

    $('.filter_title-wrap').on('click', function () {
    let key = localStorage.getItem(`filter_sort`);
    if (key === null) {
        key = '0';
    }

    localStorage.setItem(`filter_sort`, key === '0' ? '1' : '0');

    // вращение стрелок акордиона
    $(this).parent().find('.filter_title-wrap .filter_arrow').toggleClass('active');
    //выпадание и пропадание меню
    $(this).siblings('.filter_select-container').slideToggle();
});

    $('.filter-toggle').on('click', function () {
        let filter = $(this).data('filter-toggle');

        let key = localStorage.getItem(`filter_${filter}`);
        if (key === null) {
            key = '0';
        }

        localStorage.setItem(`filter_${filter}`, key === '0' ? '1' : '0');

        $(`.${filter}_wrap .filter_arrow`).toggleClass('active');
        $(`.${filter}_content`).slideToggle();
    });

    // SELECT
    $('.select .list a').on('click', function (e) {
        e.preventDefault();
        a = $(this).text();
        $(this).closest('.select').find('.visual_part span').text(a);
    });

    $('.brand_title').on('click', function () {
        $('.select1 .list1').slideToggle();
    });
    $('.select1 .list1 a').on('click', function (e) {
        e.preventDefault();
        a = $(this).text();
        $(this).closest('.select1').find('.visual_part1 span').text(a);
    });

    $('.country_title').on('click', function () {
        $('.select2 .list2').slideToggle();
    });
    $('.select2 .list2 a').on('click', function (e) {
        e.preventDefault();
        a = $(this).text();
        $(this).closest('.select2').find('.visual_part2 span').text(a);
    });

    $('.typeProduct_title').on('click', function () {
        $('.select3 .list3').slideToggle();
    });
    $('.select3 .list3 a').on('click', function (e) {
        e.preventDefault();
        a = $(this).text();
        $(this).closest('.select3').find('.visual_part3 span').text(a);
    });

    // Каталог position
    panelMenu = $('.js-panel-menu');
    offset = panelMenu.width() + 333;
    $('.catalog_menu-list  .have_menu').on('mouseenter mouseleave', function () {
        var submenu = $(this).children('.js-multi-submenu'),
            position = $(this).position();

        if (typeof position != 'undefined') {
            if (panelMenu.height() <= position.top + submenu.height() && position.top - submenu.height() > 0) {
                submenu.css({
                    top: position.top - submenu.height() + 40,
                    left: offset
                });
            } else {
                submenu.css({top: position.top, left: offset});
            }
        }
    });

    // Input вычисление
    $('.js-input-count').on('change', function () {
        const $summTarget = $($(this).data('sum-target'));
        let summ = $(this).val() * $summTarget.data('summ');

        $summTarget.html(summ.toFixed(2));
    });
    $('.quantity-button').on('click', function (e) {
        let summ = $('.value').val() * $('.summ').data('summ');
        $('.summ').html(summ.toFixed(2) + ' ₽/кг');
    });
    $('.quantity-button1').on('click', function () {
        let summ1 = $('.value1').val() * $('.summ1').data('summ');
        $('.summ1').html(summ1.toFixed(2) + ' ₽/кг');
    });
    $('.quantity-button2').on('click', function () {
        let summ2 = $('.value2').val() * $('.summ2').data('summ');
        $('.summ2').html(summ2.toFixed(2) + ' ₽/кг');
    });
    $('.quantity-button3').on('click', function () {
        let summ3 = $('.value3').val() * $('.summ3').data('summ');
        $('.summ3').html(summ3.toFixed(2) + ' ₽/кг');
    });
    $('.quantity-button4').on('click', function () {
        let summ4 = $('.value4').val() * $('.summ4').data('summ');
        $('.summ4').html(summ4.toFixed(2) + ' ₽/кг');
    });
    $('.quantity-button5').on('click', function () {
        let summ5 = $('.value5').val() * $('.summ5').data('summ');
        $('.summ5').html(summ5.toFixed(2) + ' ₽/кг');
    });
    $('.quantity-button6').on('click', function () {
        let summ6 = $('.value6').val() * $('.summ6').data('summ');
        $('.summ6').html(summ6.toFixed(2) + ' ₽/кг');
    });

    $('.quantity-button8').on('click', function () {
        let summ8 = $('.value8').val() * $('.summ8').data('summ');
        $('.summ8').html(summ8.toFixed(2) + ' ₽/кг');
    });
    $('.quantity-button9').on('click', function () {
        let summ9 = $('.value9').val() * $('.summ9').data('summ');
        $('.summ9').html(summ9.toFixed(2) + ' ₽/кг');
    });
    $('.quantity-button10').on('click', function () {
        let summ10 = $('.value10').val() * $('.summ10').data('summ');
        $('.summ10').html(summ10.toFixed(2) + ' ₽/кг');
    });
    $('.quantity-button11').on('click', function () {
        let summ11 = $('.value11').val() * $('.summ11').data('summ');
        $('.summ11').html(summ11.toFixed(2) + ' ₽/кг');
    });
    $('.quantity-button12').on('click', function () {
        let summ12 = $('.value12').val() * $('.summ12').data('summ');
        $('.summ12').html(summ12.toFixed(2) + ' ₽/кг');
    });
    $('.quantity-button13').on('click', function () {
        let summ13 = $('.value13').val() * $('.summ13').data('summ');
        $('.summ13').html(summ13.toFixed(2) + ' ₽/кг');
    });
    $('.quantity-button14').on('click', function () {
        let summ14 = $('.value14').val() * $('.summ14').data('summ');
        $('.summ14').html(summ14.toFixed(2) + ' ₽/кг');
    });
    $('.quantity-button15').on('click', function () {
        let summ15 = $('.value15').val() * $('.summ15').data('summ');
        $('.summ15').html(summ15.toFixed(2) + ' ₽/кг');
    });
    $('.quantity-button16').on('click', function () {
        let summ16 = $('.value16').val() * $('.summ16').data('summ');
        $('.summ16').html(summ16.toFixed(2) + ' ₽/кг');
    });
    $('.quantity-button17').on('click', function () {
        let summ17 = $('.value17').val() * $('.summ17').data('summ');
        $('.summ17').html(summ17.toFixed(2) + ' ₽/кг');
    });
    $('.quantity-button18').on('click', function () {
        let summ18 = $('.value18').val() * $('.summ18').data('summ');
        $('.summ18').html(summ18.toFixed(2) + ' ₽/кг');
    });
    $('.quantity-button19').on('click', function () {
        let summ19 = $('.value19').val() * $('.summ19').data('summ');
        $('.summ19').html(summ19.toFixed(2) + ' ₽/кг');
    });
    $('.quantity-button20').on('click', function () {
        let summ20 = $('.value20').val() * $('.summ20').data('summ');
        $('.summ20').html(summ20.toFixed(2) + ' ₽/кг');
    });
    $('.quantity-button21').on('click', function () {
        let summ21 = $('.value21').val() * $('.summ21').data('summ');
        $('.summ21').html(summ21.toFixed(2) + ' ₽/кг');
    });
    $('.quantity-button22').on('click', function () {
        let summ22 = $('.value22').val() * $('.summ22').data('summ');
        $('.summ22').html(summ22.toFixed(2) + ' ₽/кг');
    });
    $('.quantity-button23').on('click', function () {
        let summ23 = $('.value23').val() * $('.summ23').data('summ');
        $('.summ23').html(summ23.toFixed(2) + ' ₽/кг');
    });
    $('.quantity-button24').on('click', function () {
        let summ24 = $('.value24').val() * $('.summ24').data('summ');
        $('.summ24').html(summ24.toFixed(2) + ' ₽/кг');
    });
    $('.quantity-button25').on('click', function () {
        let summ25 = $('.value25').val() * $('.summ25').data('summ');
        $('.summ25').html(summ25.toFixed(2) + ' ₽/кг');
    });
    $('.quantity-button26').on('click', function () {
        let summ26 = $('.value26').val() * $('.summ26').data('summ');
        $('.summ26').html(summ26.toFixed(2) + ' ₽/кг');
    });
    $('.quantity-button27').on('click', function () {
        let summ27 = $('.value27').val() * $('.summ27').data('summ');
        $('.summ27').html(summ27.toFixed(2) + ' ₽/кг');
    });
    $('.quantity-button28').on('click', function () {
        let summ28 = $('.value28').val() * $('.summ28').data('summ');
        $('.summ28').html(summ28.toFixed(2) + ' ₽/кг');
    });
    $('.quantity-button29').on('click', function () {
        let summ29 = $('.value29').val() * $('.summ29').data('summ');
        $('.summ29').html(summ29.toFixed(2) + ' ₽/кг');
    });
    $('.quantity-button30').on('click', function () {
        let summ30 = $('.value30').val() * $('.summ30').data('summ');
        $('.summ30').html(summ30.toFixed(2) + ' ₽/кг');
    });
    $('.quantity-button31').on('click', function () {
        let summ31 = $('.value31').val() * $('.summ31').data('summ');
        $('.summ31').html(summ31.toFixed(2) + ' ₽/кг');
    });
    $('.quantity-button32').on('click', function () {
        let summ32 = $('.value32').val() * $('.summ32').data('summ');
        $('.summ32').html(summ32.toFixed(2) + ' ₽/кг');
    });
    $('.quantity-button33').on('click', function () {
        let summ33 = $('.value33').val() * $('.summ33').data('summ');
        $('.summ33').html(summ33.toFixed(2) + ' ₽/кг');
    });
    $('.quantity-button34').on('click', function () {
        let summ34 = $('.value34').val() * $('.summ34').data('summ');
        $('.summ34').html(summ34.toFixed(2) + ' ₽/кг');
    });
    $('.quantity-button35').on('click', function () {
        let summ35 = $('.value35').val() * $('.summ35').data('summ');
        $('.summ35').html(summ35.toFixed(2) + ' ₽/кг');
    });

    // Плейсхолдер
    $('input').blur(function (event) {
        var inputVal = this.value;
        if (inputVal) {
            this.classList.add('value-exists');
        } else {
            this.classList.remove('value-exists');
        }
    });

    // Toggle Пароль
    $('.unmask').on('click', function () {
        if ($(this).prev('input').attr('type') == 'password') {
            changeType($(this).prev('input'), 'text');
        } else {
            changeType($(this).prev('input'), 'password');
        }

        // return false;
    });

    function changeType(x, type) {
        if (x.prop('type') == type) return x; //That was easy.
        try {
            return x.prop('type', type); //Stupid IE security will not allow this
        } catch (e) {
            // //Try re-creating the element (yep... this sucks)
            // //jQuery has no html() method for the element, so we have to put into a div first
            // var html = $("<div>").append(x.clone()).html();
            // var regex = /type=(\")?([^\"\s]+)(\")?/; //matches type=text or type="text"
            // //If no match, we add the type attribute to the end; otherwise, we replace
            // var tmp = $(html.match(regex) == null ?
            //     html.replace(">", ' type="' + type + '">') :
            //     html.replace(regex, 'type="' + type + '"'));
            // //Copy data from old element
            // tmp.data('type', x.data('type'));
            // var events = x.data('events');
            // var cb = function(events) {
            //     return function() {
            //         //Bind all prior events
            //         for (i in events) {
            //             var y = events[i];
            //             for (j in y)
            //                 tmp.bind(i, y[j].handler);
            //         }
            //     }
            // }(events);
            // x.replaceWith(tmp);
            // setTimeout(cb, 10); //Wait a bit to call function
            // return tmp;
        }
    }

    // Video Player

    $(document).on('click', '.js-videoPoster', function (e) {
        //отменяем стандартное действие button
        e.preventDefault();
        var poster = $(this);
        // ищем родителя ближайшего по классу
        var wrapper = poster.closest('.js-videoWrapper');
        videoPlay(wrapper);
    });

    //вопроизводим видео, при этом скрывая постер
    function videoPlay(wrapper) {
        var iframe = wrapper.find('.js-videoIframe');
        // Берем ссылку видео из data
        var src = iframe.data('src');
        // скрываем постер
        wrapper.addClass('videoWrapperActive');
        // подставляем в src параметр из data
        iframe.attr('src', src);
    }

    //Автозаполнение
    var source = ['Apples', 'Oranges', 'Bananas'];
    $('#search_form').autocomplete({
        source: source
    });

    $('#slider').slider();

    //CHECKBOX
    $('input[type=checkbox]').click(function () {
        if (this.checked) {
            $('#FullName').attr('disabled', 'disabled').val('Иванов Иван');
            $('#phone').attr('disabled', 'disabled').val('+7 950 654-98-98');
            $('#email').attr('disabled', 'disabled').val('info@rrrr.com');
            $('.data_adress').attr('disabled', 'disabled').val('г. Киров, ул. Ленина 2 - 123');
        }
    });

    // Работа каталога | Избранное
    $(document).on('click', '.card_heart, [data-fav-add]', function () {
        let product = $(this).data('product');
        let csrfParam = $('meta[name="csrf-param"]').attr('content');
        let csrfToken = $('meta[name="csrf-token"]').attr('content');

        // Создаем ключ для временного хранения избранного
        let favoriteToken = localStorage.getItem('favorite_token');
        if (favoriteToken === null) {
            $.ajax({
                type: 'POST',
                contentType: 'application/x-www-form-urlencoded',
                url: `${window.location.origin}/catalog/create-favorite-token`,
                data: {[csrfParam]: csrfToken}
            }).done((response) => {
                localStorage.setItem('favorite_token', response);
                favoriteToken = response;
            });
        }

        // Добавляем продукт в избранное
        $.ajax({
            type: 'POST',
            contentType: 'application/x-www-form-urlencoded',
            url: `${window.location.origin}/catalog/favorite/${product}`,
            data: {[csrfParam]: csrfToken, favoriteToken}
        }).done((response) => {
            if (response === 'liked') {
                document.dispatchEvent(new Event('add-to-favorites'));
                $(this).addClass('liked');
                ym(90052146,'reachGoal','add-favorite');
            } else {
                $(this).removeClass('liked');
                ym(90052146,'reachGoal','delete-favorite');
            }

            showFavoritesCount();
        });
    });
    function showFavoritesCount() {
        $.ajax({
            type: 'GET',
            url: `${window.location.origin}/catalog/favorite-count`,
        }).done((response) => {
            let $favoriteCount = $('[data-favorite-count]');

            $favoriteCount.html(response.result).removeClass('--hide');

            if (response.result > 0) {
                $favoriteCount.removeClass('_empty');
            } else {
                $favoriteCount.addClass('_empty');
            }
        });
    }

    // Работа каталога | Корзина
    $(document).on('click', '[data-add-item-basket]', function () {
        let product = $(this).data('product');
        let count = $('#js-catalog_item__' + product).val();

        $('.basket_modal1').find('.minus').data('product', product);
        $('.basket_modal1').find('.plus').data('product', product);
        $('.basket_modal1').find('.basket_modal-img img').attr('src', $(this).data('url'));
        $('.basket_modal1').find('.basket_modal-name').html($(this).data('title'));

        document.dispatchEvent(new CustomEvent('add-basket-item',
            {detail: {
                    productId: product,
                    quantity: count
                }
            }
        ));

        setTimeout(() => {
            document.dispatchEvent(new CustomEvent('openModalBasket', {
                detail: {
                    productId: product,
                    quantity: count
                }
            }))
        }, 300);
    });

    document.addEventListener('add-basket-item', (e) => {
        const product = e.detail.productId;
        const count = e.detail.quantity;
        const notNew = e.detail.notNew;
        console.log(e.detail)
        const csrfParam = $('meta[name="csrf-param"]').attr('content');
        const csrfToken = $('meta[name="csrf-token"]').attr('content');

        $.ajax({
            type: 'POST',
            contentType: 'application/x-www-form-urlencoded',
            url: `${window.location.origin}/basket/${product}`,
            data: {[csrfParam]: csrfToken, count},
            success: function (response) {
                $('[data-cart-total]').html(response['basket_total']);

                let totalCount = response['basket_total_count'];
                showBasketCount(totalCount);

                document.dispatchEvent(new Event('add-basket-success'));
                document.dispatchEvent(new Event('update-product-counts'));

                const basketItems = document.querySelector('[data-basket-item-list]');
                if (basketItems && !notNew) {
                    if (response.htmlItem && !notNew) {
                        const newItem = document.createElement('div');
                        newItem.innerHTML = response.htmlItem;
                        basketItems.appendChild(newItem);
                        document.dispatchEvent(new CustomEvent('addedBasketItem'));
                    } else {
                        const counter = document.querySelector(`[data-basket-item] [data-basket-count][data-product="${product}"]`);
                        if (counter) {
                            let amount = parseFloat(response['item_amount']);
                            amount = Math.round(amount * 100) / 100;
                            counter.value = amount;

                            const item = counter.closest('[data-basket-item]');
                            if (item) {
                                const priceBlock = item.querySelector('.total_value');
                                if (priceBlock) {
                                    priceBlock.innerHTML = response['item_total'] + '₽';
                                }
                            }
                        }
                    }
                }


                if (document.querySelectorAll('[data-basket-item]').length) {
                    updateBasketTotal(response);
                }

                if (window.Ya && window.Ya._metrika) {
                    console.log(window.Ya, window.Ya._metrika)
                    ym(90052146,'reachGoal','add-basket');
                }
            }
        });
    });

    $(document).on('click', '[data-delete-product]', function () {
        let product = $(this).data('id');
        let csrfParam = $('meta[name="csrf-param"]').attr('content');
        let csrfToken = $('meta[name="csrf-token"]').attr('content');
        let parent = $(this).parent();
        parent.addClass('_deleted');

        document.dispatchEvent(new CustomEvent('delete-basket-product',
            {detail: { basketItem: parent[0] }}
        ));

        $.ajax({
            type: 'DELETE',
            contentType: 'application/x-www-form-urlencoded',
            url: `${window.location.origin}/basket/` + product,
            data: {[csrfParam]: csrfToken},
            success: function (response) {
                ym(90052146,'reachGoal','delete-basket');
                updateBasketTotal(response);
            },
            error: function (a, b, c, d) {
                parent.removeClass('_deleted');
            }
        });
    });

    $('[data-toggle-pass]').on('click', function () {
        $(this).toggleClass('shown');
        const $input = $(this).parent().find('input').first();

        if ($input.length) {
            if ($(this).hasClass('shown')) {
                $input.attr('type', 'text');
            } else {
                $input.attr('type', 'password');
            }
        }

        return false;
    });
});


// меню связи

const hamb = document.querySelector('#hamburger');
const popup = document.querySelector('#popup');
const body = document.body;
const menuCross = document.querySelector('#menu #close');
// const menu = document.querySelector("#menu").cloneNode(1);


// hamb.addEventListener('click', hambHandler);
// menuCross.addEventListener('click', hambHandler);
let modalActive = false;

// Модалка
const updateButtonEvents = () => {
    document.querySelectorAll('[data-btn]').forEach((item) => {

        item.addEventListener('click', function () {
            // document.body.style.overflow = "hidden";
            let dataValue = this.getAttribute('data-btn');

            let modal = document.querySelector('.' + dataValue);

            if (modal) {
                modal.style.display = 'flex';
                modal.style.visibility = 'visible';
            }

            const yandexGoal = item.dataset.goalYandexSubmit;
            const googleGoal = item.dataset.goalGoogleSubmit;

            const yandexInput = modal.querySelector('[name="yandexGoal"]');
            const googleInput = modal.querySelector('[name="googleGoal"]');

            yandexInput.value = yandexGoal;
            googleInput.value = googleGoal;
        });
    });
};
document.addEventListener('DOMContentLoaded', (event) => {
    updateButtonEvents();
});

function hambHandler(e) {
    e.preventDefault();

    if (!modalActive) {
        popup.classList.add('open');
        hamb.classList.add('active');
        body.style = 'overflow: hidden';
        renderPopup();
        updateButtonEvents();
        modalActive = true;
        return;
    }

    popup.classList.remove('open');
    hamb.classList.remove('active');
    body.style = '';
    renderPopup();
    updateButtonEvents();
    modalActive = false;


}

function renderPopup() {
    popup.appendChild(menu);
}

// const links = Array.from(menu.children);

// links.forEach((link) => {
//   link.addEventListener("click", closeOnClick, true);
// });

if (popup) {
    popup.addEventListener('click', (event) => {
        const targetId = event.target.id;
        const currentTargetId = event.currentTarget.id;

        if (targetId == currentTargetId) {
            closeOnClick();
        }

        if (targetId == 'close') {
            closeOnClick();
        }

        document.querySelector('.arrow_down').click();
    });
}


function closeOnClick() {
    popup.classList.remove('open');
    hamb.classList.remove('active');
    body.classList.remove('noscroll');
}


//

const passwordElement = document.querySelector('.field-loginform-password');

if (passwordElement) {
    const toggleButton = document.createElement('div');
    toggleButton.classList.add('field-loginform-password-toggle');
    passwordElement.appendChild(toggleButton);

    toggleButton.addEventListener('click', function() {
        const input = passwordElement.querySelector('input');
        if (input) {
            if (input.type === 'password') {
                if (!toggleButton.classList.contains('field-loginform-password-toggle_invisible')){
                    toggleButton.classList.add('field-loginform-password-toggle_invisible');
                }
                input.type = 'text';
            } else {
                if (toggleButton.classList.contains('field-loginform-password-toggle_invisible')){
                    toggleButton.classList.remove('field-loginform-password-toggle_invisible');
                }
                input.type = 'password';
            }
        }
    });
}